.root {
  --checkbox--color-background: var(--checkbox--color--contrast, var(--theme--color--mono--white));
  --checkbox--color-disabled-background: var(--theme--color--grey--light);
  --checkbox--color-main: var(--checkbox--color--main, var(--theme--color--mono--black));

  --checkbox--input-size: 20px;
  --checkbox--input-size-inset: 12px;
  --checkbox--border-radius: 4px;
  --checkbox--border-width: 1px;

  &.isDisabled {
    --checkbox--color-background: var(--checkbox--color-disabled-background);
    border-color: var(--theme--color--grey--main);
    --checkbox--color-main: var(--theme--color--grey--main);
    cursor: not-allowed;
  }

  &.isChecked::before {
    transform: scale(1);
  }

  & {
    -webkit-appearance: none;
    appearance: none;
    background-color: var(--checkbox--color-background);
    margin: 0;
    font: inherit;
    color: var(--checkbox--color-main);
    width: var(--checkbox--input-size);
    height: var(--checkbox--input-size);
    border: var(--checkbox--border-width) solid var(--checkbox--color-main);
    border-radius: var(--checkbox--border-radius);
    display: grid;
    place-content: center;
    cursor: pointer;
    flex-shrink: 0;

    &::before {
      content: '';
      width: var(--checkbox--input-size-inset);
      height: var(--checkbox--input-size-inset);
      clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
      transform: scale(0);
      transform-origin: center;
      transition: 120ms transform ease-in-out;
      box-shadow: inset 1em 1em var(--checkbox--color-main);
    }

    &:focus-visible, &:focus, &:focus-within {
      outline: var(--theme--token--focus--outline);
      outline-offset: var(--theme--token--focus--offset);
    }
  }
}